import * as z from "zod";

// CIDR ranges are validated with the same acceptance as the proxy's
// `Destination::compile` (`services/proxy/src/network/types.rs`), so a
// malformed destination is rejected at mutation time instead of being silently
// dropped by the proxy — which would fail open for a DENY rule.
export const destinationSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("hostnameGlob"), pattern: z.string().min(1) }),
  z.object({
    type: z.literal("cidr"),
    range: z.union([z.cidrv4(), z.cidrv6()]),
  }),
]);

// The exit node's dial ACL (`DESTINATION_CIDRS`) is derived from the network's
// CIDR routes, so it has to be recomputed whenever those routes change.
export function collectDestinationCidrs(
  routes: ReadonlyArray<{ destinationType: string; destination: string }>
): string {
  return routes
    .filter((r) => r.destinationType === "cidr")
    .map((r) => r.destination)
    .join(",");
}
